module.exports = __webpack_public_path__ + "img/drone-lago-di-garda-1.95717e9e.jpg";